export default "./dist/stdassets/cursors/digitizePoint.cur";